// Tracks recently-viewed products per browser (localStorage) so the cart's
// "Complete the set" upsell (see bigfrenchies-script.js) can seed Shopify's
// native recommendation engine from what the shopper has actually been
// looking at, instead of only from whatever they've already added to cart.
//
// This is the free, no-app version of "browsing history" personalization:
// session/device-scoped only (no server, no customer account, no cross-
// device sync). It records a lightweight {id, handle, viewedAt} entry per
// product page view, most-recent-first, capped at MAX_ITEMS. It never
// breaks anything if storage is unavailable (private browsing, quota
// exceeded, etc.) - recordView() and readHistory() both fail silently, and
// the cart upsell simply falls back to today's existing cart-item-seeded
// behavior in that case. See the getRecentlyViewedSeedId() addition in
// bigfrenchies-script.js for how this list gets used.
(function() {
  var STORAGE_KEY = 'bf_recently_viewed';
  var MAX_ITEMS = 10;

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // Storage unavailable - fail silently.
    }
  }

  function recordView(product) {
    if (!product || product.id == null) return;
    var history = readHistory().filter(function(entry) {
      return entry && entry.id !== product.id;
    });
    history.unshift({ id: product.id, handle: product.handle, viewedAt: Date.now() });
    writeHistory(history.slice(0, MAX_ITEMS));
  }

  function getCurrentProduct() {
    // Present on every product page load regardless of theme customization -
    // see the ProductJson-{{section.id}} script tag in sections/main-product.liquid.
    var script = document.querySelector('script[id^="ProductJson-"]');
    if (!script) return null;
    try {
      var data = JSON.parse(script.textContent);
      return { id: data.id, handle: data.handle };
    } catch (e) {
      return null;
    }
  }

  if (!document.body || !document.body.classList.contains('template-product')) return;
  recordView(getCurrentProduct());
})();
